import { Vue, Component, Prop } from "vue-property-decorator";

@Component
class LightboxController extends Vue {
    @Prop({type: String, default: ""}) public path!: string;

    public getData() {
        if (this.path !== "") {
            // Force it to open the lightbox (and clean it)
            // Avoid the click to look unrespondable
            this.$store.commit("updateLightbox", [{}]);

            fetch(this.path, { credentials: "same-origin" })
                .then(response => response.json())
                .then(json => this.$store.commit("updateLightbox", json));
        }
    }
}

export default LightboxController;
